import axios, { AxiosError } from "axios";
import { useQuery, UseQueryOptions } from "react-query";

import { GetCallsFromAPI } from "../types";
import { getAppConfigSetting } from "../utils/getAppConfigSetting";
import { GET_MARGIN_CALLS } from "./constants";
import queryKeys from "./queryKeys";

const useGetCallsAndAlertsOpenDetails = (
  accountNumber?: string,
  options?: UseQueryOptions<GetCallsFromAPI, AxiosError>
) => {
  const marginCallsApiURL = `${getAppConfigSetting(
    "apiUrl"
  )}${GET_MARGIN_CALLS}`;

  const fetchMarginCalls = async (): Promise<GetCallsFromAPI> => {
    const { data } = await axios.get(
      `${marginCallsApiURL}?status=OPEN&account=${accountNumber}`,
      {
        withCredentials: true,
      }
    );
    return data;
  };

  return useQuery<GetCallsFromAPI, AxiosError>(
    [queryKeys.getCallsAndAlertsOpenDetails],
    fetchMarginCalls,
    {
      enabled: false,
      ...options,
    }
  );
};

export default useGetCallsAndAlertsOpenDetails;
